import { useCallback, useContext } from 'react';
import SecondaryCtaType from '~/constants/SecondaryCtaType';
import ModalContext from '~/context/vdp/ModalContext';
import { useViewSimilarVehicles } from '~/hooks/vdp/cta';
import useSecondaryCtaButtonState from '~/hooks/vdp/selectors/useSecondaryCtaButtonState';

const dummyFunction = () => {};

function useClickHandler(): () => void {
  const { setLockTimerModalOpen, setSignUpForAlertsModalOpen } =
    useContext(ModalContext);
  const { type } = useSecondaryCtaButtonState();
  const viewSimilarVehicles = useViewSimilarVehicles();

  const notifyMe = useCallback(() => {
    setLockTimerModalOpen(true);
  }, [setLockTimerModalOpen]);

  const getAlerts = useCallback(() => {
    setSignUpForAlertsModalOpen(true);
  }, [setSignUpForAlertsModalOpen]);

  switch (type) {
    case SecondaryCtaType.Default:
      return dummyFunction;
    case SecondaryCtaType.GetAlerts:
      return getAlerts;
    case SecondaryCtaType.NotifyMe:
      return notifyMe;
    case SecondaryCtaType.ViewMoreCars:
      return viewSimilarVehicles;
    case SecondaryCtaType.ViewSimilarVehicles:
      return viewSimilarVehicles;
    default:
      return dummyFunction;
  }
}

export default function useSecondaryButtonHandler(
  onClick: () => void = dummyFunction
) {
  const handleClick = useClickHandler();

  return useCallback(() => {
    onClick();
    handleClick();
  }, [handleClick, onClick]);
}
